export default {
  title: 'محصولات',

  list: {
    title: 'لیست محصولات',

    table: {
      header: {
        row: 'ردیف',
        name: 'عنوان',
        shopName: 'نام نمایشی در فروشگاه',
        code: 'کد',
        barcode: 'بارکد',
        price: 'قیمت ماهیانه',
        salePrice: 'قیمت حراج (براساس ماه)',
        image: 'عکس',
        category: 'دسته بندی',
        creator: 'ایجاد کننده',
        type: 'نوع',
        status: 'وضعیت',
        shops: 'فروشگاه ها',
        lastModifiedDate: 'تاریخ بروزرسانی'
      },

      filters: {
        status: {
          all: 'همه',
          notConnect: 'عدم اتصال',
          draft: 'پیش نویس',
          waiting: 'در انتظار',
          published: 'منتشر شده',
          personal: 'خصوصی'
        },

        type: {
          all: 'همه',
          simpleProduct: 'محصول ساده',
          variableProduct: 'محصول متغیر'
        }
      }
    }
  },

  insert: {
    title: 'افزودن محصول',

    labels: {
      importData: 'آپلود اول دوره محصول'
    },

    types: {
      label: 'انتخاب نوع افزودن',
      useral: 'افزودن به یوزرال',
      woocommerce: 'افزودن به {shopName} و یوزرال'
    },

    table: {
      header: {
        inventory: 'موجودی انبار',
        barcode: 'بارکد',
        price: 'قیمت',
        salePrice: 'قیمت حراج',
        delete: 'حذف'
      }
    },

    description: {
      title: 'توضیحات',

      useralDescription: 'اطلاعات این محصول فقط در سامانه یوزرال ثبت میشود.',
      woocommerceDescription: 'اطلاعات محصول به صورت مستقیم در فروشگاه شما در وضعیت در حال بازبینی ثبت میشود.',
      notCategorySelected: 'هیچ دسته بندی انتخاب نشده است',
      noAttributesExistForCategory: 'هیچ ویژگی برای این دسته بندی وجود ندارد',
      noAttributeChooseForVariables: 'هیچ ویژگی به عنوان متغیر انتخاب نشده است',
      inventory: 'در این صفحه شما می توانید موجودی کل محصول را وارد کنید. در صورتی که تعداد موجودی برابر با صفر باشد، محصول ناموجود در نظر گرفته خواهد شد.',
      attribute: 'شما می توانید ویژگی مورد نظر خود را انتخاب و به لیست ویژگی های محصول اضافه نمایید. در صورتی که محصول از نوع متغیر باشد، شما میتوانید <b>یکی</b> از ویژگی ها را به عنوان ویژگی متغیر محصول انتخاب نمایید'
    },

    notifications: {
      type: {
        notSelected: {
          error: 'نوع افزودن انتخاب نشده است'
        }
      },
      notConnectToServer: {
        error: 'به علت عدم اتصال به سایت، قادر به افزودن محصول نمی باشید'
      },
      imageUpload: {
        success: 'عکس با موفقیت آپلود شد'
      },
      imageRemove: {
        success: 'لوگو با موفقیت حذف شد'
      },
      insertProduct: {
        success: 'اطلاعات محصول با موفقیت ثبت شد',
        error: 'ثبت اطلاعات محصول با خطا مواجه شد'
      },
      woocommerceInsertProduct: {
        success: 'اطلاعات محصول با موفقیت  در فروشگاه ثبت شد',
        error: 'ثبت اطلاعات محصول با خطا مواجه شد'
      }
    },

    accordionList: {
      brand: {
        title: 'برند مورد نظر را انتخاب نمایید',

        insert: {
          title: 'افزودن برند جدید',
          brand: 'عنوان برند'
        },

        edit: {
          title: 'ویرایش برند',
          category: 'عنوان برند'
        },

        delete: {
          title: 'حذف برند',
          message: 'با حذف این برند، تمامی اطلاعات مرتبط با آن نیز حذف می شود.'
        }
      },

      category: {
        title: 'دسته بندی مورد نظر را انتخاب نمایید',

        insert: {
          title: 'افزودن دسته بندی جدید',
          category: 'عنوان دسته بندی'
        },

        edit: {
          title: 'ویرایش دسته بندی',
          category: 'عنوان دسته بندی'
        },

        delete: {
          title: 'حذف دسته بندی',
          message: 'با حذف این دسته بندی، تمامی اطلاعات مرتبط با آن نیز حذف می شود.'
        }
      },


      attributes: 'ویژگی ها',
      insertAttribute: {
        title: 'افزودن ویژگی جدید',
        attribute: 'عنوان ویژگی',
        values: 'مقادیر'
      },
      editAttribute: {
        title: 'ویرایش ویژگی',
        attribute: 'عنوان ویژگی',
        values: 'مقادیر'
      },

      buttons: {
        accept: 'تائید',
        cancel: 'انصراف'
      },

      alert: {
        title: 'پیغام',
        brandCreated: 'برند با موفقیت ایجاد شد',
        brandUpdated: 'برند با موفقیت ویرایش شد',
        brandDeleted: 'برند با موفقیت حذف شد',
        categoryCreated: 'دسته بندی با موفقیت ایجاد شد',
        categoryUpdated: 'دسته بندی با موفقیت ویرایش شد',
        categoryDeleted: 'دسته بندی با موفقیت حذف شد',
        errorTitle: 'خطا',
        error: 'فرآیند با خطا همراه شد'
      }
    }
  },

  edit: {
    title: 'ویرایش محصول',
    dynamicTitle: 'ویرایش {name}',

    table: {
      header: {
        inventory: 'موجودی انبار',
        barcode: 'بارکد',
        price: 'قیمت',
        salePrice: 'قیمت حراج',
        delete: 'حذف'
      }
    },

    description: {
      title: 'توضیحات',
      body: 'اطلاعات محصول به صورت مستقیم در فروشگاه شما در وضعیت در حال بازبینی ثبت میشود.'
    },

    notifications: {
      type: {
        notSelected: {
          error: 'نوع افزودن انتخاب نشده است'
        }
      },
      notConnectToServer: {
        error: 'به علت عدم اتصال به سایت، قادر به افزودن محصول نمی باشید'
      },
      imageUpload: {
        success: 'عکس با موفقیت آپلود شد'
      },
      imageRemove: {
        success: 'لوگو با موفقیت حذف شد'
      },
      editProduct: {
        success: 'اطلاعات محصول با موفقیت ثبت شد',
        error: 'ثبت اطلاعات محصول با خطا مواجه شد'
      },
      woocommerceEditProduct: {
        success: 'اطلاعات محصول با موفقیت  در فروشگاه ثبت شد',
        error: 'ثبت اطلاعات محصول با خطا مواجه شد'
      },
      deleteVariant: {
        success: 'اطلاعات متغیر با موفقیت حذف شد',
        error: 'حذف اطلاعات متغیر با خطا همراه شد'
      },
      deleteProduct: {
        success: 'اطلاعات محصول با موفقیت حذف شد',
        error: 'حذف اطلاعات محصول با خطا همراه شد'
      }
    },

    confirmations: {
      delete: {
        title: 'تائیدیه',
        body: 'آیا از حذف این محصول اطمینان دارید؟'
      },
      deleteVariable: {
        title: 'تائیدیه',
        body: 'آیا از حذف این متغیر اطمینان دارید؟ در صورت تائید، اطلاعات محصول از فروشگاه شما نیز حذف می شود!'
      }
    }
  },

  product: {
    title: 'محصول',

    labels: {
      withoutPrice: 'بدون قیمت',
      rangePrice: 'از {min} تا {max}',
      openingBalance: 'اول دوره'
    },

    importantData: {
      price: 'قیمت (براساس ماه)',
      salePrice: 'قیمت حراج',
      score: 'امتیاز',
      slug: 'نامک',
      type: 'نوع'
    },

    actions: {
      languages: 'زبان ها',
      modules: 'ماژول+ ها',
      addons: 'افزودنی ها',
      setting: 'تنظیمات',
      logs: 'لیست لاگ ها'
    },

    languages: {
      title: 'زبان محصول',

      labels: {
        importExportLanguage: 'آپلود و دریافت فایل زبان',
        importLanguage: 'آپلود فایل زبان',
        export: 'دریافت',
        default: '(پیش فرض)'
      },

      statusTypes: {
        0: 'پیش نویس شده',
        2: 'منتشر شده'
      },

      actions: {
        draft: 'پیش نویس',
        publish: 'انتشار',
        republish: 'بروزرسانی',
        import: 'آپلود',
        export: 'دانلود',
        aiSuggest: 'AI'
      },

      table: {
        header: {
          rowNumber: 'ردیف',
          name: 'عنوان',
          status: 'وضعیت',
          remainingTranslate: 'ترجمه نشده',
          translated: 'ترجمه شده'
        }
      },

      notifications: {
        insert: {
          success: 'زبان با موفقیت ایجاد شد',
          error: 'افزودن زبان با خطا همراه شد'
        },

        edit: {
          success: 'زبان مورد نظر با موفقیت بروز شد',
          error: 'بروزرسانی زبان مورد نظر با خطا همراه شد'
        },

        publish: {
          success: 'زبان مورد نظر با موفقیت منتشر شد',
          error: 'انتشار زبان مورد نظر با خطا همراه شد',
          translateIncomplete: 'ترجمه کامل نشده است'
        },

        draft: {
          success: 'زبان مورد نظر با موفقیت پیش نویس شد',
          error: 'پیش نویس کردن زبان مورد نظر با خطا همراه شد'
        },

        updateKeyWithAi: {
          success: 'آیتم مورد نظر با موفقیت بروزرسانی شد',
          error: 'بروزرسانی آیتم مورد نظر با خطا همراه شد',
          tooManyRequest: 'درخواست قبلی در حال پردازش است لطفا {min} دقیقه بعد تلاش کنید'
        },

        deleteKey: {
          success: 'آیتم مورد نظر با موفقیت حذف شد',
          error: 'حذف آیتم مورد نظر با خطا همراه شد'
        },

        delete: {
          success: 'زبان مورد نظر با موفقیت حذف شد',
          error: 'حذف زبان مورد نظر با خطا همراه شد'
        },

        importLanguage: {
          success: 'آپلود فایل زبان با موفقیت انجام شد',
          error: 'درخواست آپلود فایل زبان با خطا همراه شد'
        },

        parseError: {
          slug: 'نامک وارد شده قبلا استفاده شده است'
        }
      },

      validators: {
        slug: 'نامک معتبر نیست',
      },

      confirmations: {
        changeStatus: {
          title: 'تاییدیه ویرایش وضعیت',
          body: 'آیا از ویرایش وضعیت زبان اطمینان دارید؟',
          republishBody: 'آیا از بروزرسانی زبان اطمینان دارید؟'
        },

        importLanguage: {
          title: 'تاییدیه آپلود فایل زبان',
          body: 'آیا از آپلود فایل زبان اطمینان دارید؟'
        },

        aiSuggestTranslate: {
          title: 'تاییدیه ترجمه زبان',
          body: 'آیا از ترجمه زبان با استفاده از هوش مصنوعی اطمینان دارید؟'
        },

        aiTranslateKey: {
          title: 'تاییدیه ترجمه زبان',
          body: 'با این کار همه ترجمه های قبلی از بین می رود، آیا از ترجمه زبان با استفاده از هوش مصنوعی اطمینان دارید؟'
        },

        deleteChangedKey: {
          title: 'تاییدیه حذف تغییرات کلید زبان',
          body: 'آیا از حذف تغییرات کلید زبان اطمینان دارید؟'
        },

        delete: {
          title: 'تاییدیه حذف زبان',
          body: 'آیا از حذف زبان اطمینان دارید؟'
        }
      },

      insert: {
        title: 'افزودن زبان'
      },

      edit: {
        title: 'ویرایش زبان',

        editKey: {
          title: 'ویرایش کلید زبان'
        }
      },

      language: {
        title: '',

        table: {
          header: {
            rowNumber: 'ردیف',
            subject: 'عنوان',
            sourceValue: 'مقدار مبدا',
            content: 'محتوا',
            aiSuggest: 'پیشنهاد هوش مصنوعی',
            description: 'توضیحات',
            delete: 'حذف'
          }
        },

        tabs: {
          all: 'همه',
          technicalProblem: 'ترجمه نشده'
        },

        labels: {
          all: 'همه',
          name: 'نام',
          slug: 'نامک',
          aiSuggest: 'پیشنهاد هوش مصنوعی',
          rtl: 'زبان راست چین است',
          status: 'زبان فعال باشد'
        },

        actions: {
          dashboard: 'داشبورد',
          keys: 'ترجمه ها'
        },

        slugOptions: {
          zh: 'چینی',
          en: 'انگلیسی',
          hi: 'هندی',
          es: 'اسپانیایی',
          fr: 'فرانسوی',
          ar: 'عربی',
          bn: 'بنگالی',
          pt: 'پرتقالی',
          ru: 'روسی',
          ur: 'اردو',
          ja: 'ژاپنی',
          de: 'آلمانی',
          jv: 'جاوه ای',
          sw: 'سواحیلی',
          tr: 'ترکی',
          fa: 'فارسی'
        },

        dashboard: {
          title: 'داشبورد زبان',
        }
      }
    },

    setting: {
      title: 'تنظمیات مخصول',

      labels: {
        subscription: 'اشتراک',
        plan: 'پلن فروش',
        addon: 'افزودنی',
        refundGuaranteePeriod: 'دوره گارانتی مرجوع',
        calculateCurrentCreditInDowngrade: 'محاسبه اعتبار فعلی در تنزل',
        calculateCurrentCreditInUpgrade: 'محاسبه اعتبار فعلی در ارتقاء',
        calculateCurrentCreditInCancel: 'محاسبه اعتبار فعلی در کنسل کردن',
        calculateCurrentAddonCreditInCancel: 'محاسبه اعتبار فعلی افزودنی در کنسل کردن',
      }
    },

    logs: {
      title: 'لاگ های محصول',
      dynamicTitle: 'لاگ های {name}',

      table: {
        header: {
          rowNumber: 'ردیف',
          user: 'کاربر',
          description: 'توضیحات',
          date: 'تاریخ'
        }
      },

      dialogs: {
        title: 'توضیحات',

        noChange: 'فیلدی تغییری داده نشده است'
      }
    },


    type: {
      simple: 'محصول ساده',
      variant: 'محصول متغیر',
      service: 'خدمت'
    }
  },

  select: {
    title: 'لیست محصولات',

    table: {
      header: {
        select: 'انتخاب',
        rowNumber: 'ردیف',
        name: 'عنوان',
        code: 'کد',
        barcode: 'بارکد',
        price: 'قیمت',
        image: 'عکس',
        category: 'دسته بندی',
        type: 'نوع',
        variant: 'متغیر',
        salePrice: 'قیمت حراج',
        purchasePrice: 'قیمت خرید',
        purchasePriceWithVat: 'قیمت تمام شده خرید',
        quantity: 'تعداد',
        inventory: 'موجودی',
        storeroomInventory: 'موجودی انبار',
        totalInventory: 'موجودی کل',
        storeroom: 'انبار',
        edit: 'ویرایش'
      },

      filters: {
        type: {
          all: 'همه',
          simple: 'محصول ساده',
          variant: 'محصول متغیر'
        }
      }
    }
  },

  trash: {
    title: 'سطل زباله محصول',

    table: {
      header: {
        rowNumber: 'ردیف',
        name: 'عنوان',
        code: 'کد',
        image: 'عکس',
        type: 'نوع',
        delete: 'حذف',
        restore: 'بازگردانی'
      }
    },

    confirmations: {
      delete: {
        title: 'تاییدیه حذف محصول',
        body: 'آیا از حذف دایم {name} اطمینان دارید؟'
      }
    },

    notifications: {
      restore: {
        success: 'محصول با موفقیت بازگردانده شد',
        error: 'بازگردانی محصول با خطا همراه شد'
      },
      delete: {
        success: 'محصول با موفقیت حذف شد',
        error: 'حذف محصول با خطا همراه شد'
      }
    }
  },

  openingBalance: {
    productList: 'لیست محصولات',

    insert: {
      title: 'افزودن اول دوره انبار'
    },


    productType: {
      simple: 'محصول ساده',
      variant: 'محصول متغیر',
      service: 'خدمت'
    },

    labels: {
      count: 'تعداد',
      price: 'قیمت',
      delete: 'حذف اول دوره',
      insertProduct: 'افزودن محصول جدید',
      importData: 'آپلود فایل اول دوره محصولات'
    },

    table: {
      header: {
        rowNumber: 'ردیف',
        barcode: 'بارکد',
        name: 'محصول',
        variant: 'متغیر',
        count: 'تعداد',
        unitPrice: 'مبلغ واحد',
        totalPrice: 'مبلغ کل',
        delete: 'حذف'
      }
    },

    validators: {
      valueExist: 'این مقدار در لیست وجود دارد',
      productExist: '{name} در لیست وجود دارد',
      barcode: 'محصولی با این بارکد موجود نمی باشد و یا در اول دوره وجود دارد',
      lock: 'اول دوره قفل است'
    },

    notifications: {
      insert: {
        success: 'اول دوره انبار با موفقیت ثبت شد',
        error: 'ثبت اول دوره انبار با خطا همراه شد!'
      },
      importData: {
        success: 'آپلود فایل اول دوره با موفقیت انجام شد',
        error: 'درخواست آپلود اول دوره با خطا همراه شد'
      },
      edit: {
        success: 'اول دوره محصول مورد نظر با موفقیت بروزرسانی شد',
        error: 'بروزرسانی اول دوره محصول مورد نظر با خطا همراه شد'
      },
      delete: {
        success: 'اول دوره محصول مورد نظر با موفقیت حذف شد',
        error: 'حذف اول دوره محصول مورد نظر با خطا همراه شد'
      }
    },

    confirmations: {
      delete: {
        title: 'تائیدیه حذف',
        body: 'آیا از حذف اول دوره محصول مورد نظر اطمینان دارید؟'
      }
    }
  },

  labels: {
    type: 'نوع محصول',
    id: 'شناسه',
    barcode: 'بارکد',
    name: 'نام',
    serviceName: 'نام خدمت',
    productShopName: 'نام نمایشی در فروشگاه',
    category: 'دسته بندی',
    serviceCategory: 'دسته بندی خدمات',
    price: 'قیمت ماهیانه',
    status: 'وضعیت',
    perMonth: 'ماه',
    purchasePrice: 'قیمت خرید',
    productPrice: 'قیمت محصول',
    servicePrice: 'قیمت خدمت',
    salePrice: 'قیمت حراج',
    setSalePriceRange: 'تعیین بازه حراج',
    saleStartDate: 'تاریخ شروع حراج',
    saleEndDate: 'تاریخ پایان حراج',
    phaseOut: 'توقف تولید',
    onlyUseral: 'محصول فقط در یوزرال ساخته شود',
    description: 'توضیحات',
    inventory: 'موجودی انبار',
    chooseAttribute: 'انتخاب ویژگی',
    chooseCategory: 'انتخاب دسته بندی',
    withoutCategory: 'بدون دسته بندی',
    removeProduct: 'حذف محصول',
    createVariable: 'ایجاد متغیر جدید',
    removeVariable: 'حذف متغیر',
    currentProduct: 'فعال'
  },

  notifications: {
    setting: {
      success: 'تنظیمات محصول با موفقیت ویرایش شد',
      error: 'ویرایش تنظمیات محصول با خطا همراه شد'
    }
  },

  validators: {
    dateHelp: 'ورودی باید به صورت {date} وارد شود.',
    wrongInputValues: 'اطلاعات وارد شده صحیح نمی باشد',
    saleDateRange: 'بازه شروع و پایان حراج به صورت صحیح وارد نشده است',
    imageSize: 'حجم فایل انتخاب شده بیش از حد مجاز است',
    fileFormat: 'فرمت فایل انتخاب شده مجاز نیست',
    variantExist: 'متغیری با این ویژگی وجود دارد',
    variantListTotalCount: 'تعداد کل حالت های ممکن برابر است با {max}',
    price: 'فیلد قیمت الزامی است',
    salePrice: 'قیمت حراج نمی تواند از قیمت اصلی بیشتر یا مساوی باشد',
    variableSalePrice: 'قیمت حراج متغیر با بارکد {barcode} نمی تواند از قیمت اصلی بیشتر یا مساوی باشد',
    code: 'محصولی با این کد، وجود دارد و یا کد اشتباه می باشد',
    barcode: 'محصولی با این بارکد، وجود دارد و یا بارکد اشتباه می باشد',
    variableBarcode: 'بارکد متغیر ردیف {row} تکراری است',
    title: 'محصولی با این نام وجود دارد و یا نام به صورت صحیح وارد نشده است',
    saleStartDate: 'تاریخ شروع حراج به صورت صحیح وارد نشده است.',
    saleEndDate: 'تاریخ پایان حراج به صورت صحیح وارد نشده است.',
    productIsUsed: 'این محصول به دلیل وجود گردش قابل حذف نیست',
    variantIsUsed: 'این متغیر به دلیل وجود گردش قابل حذف نیست',
    typeRestrict: 'این محصول به دلیل وجود گردش قابل تغییر نوع نیست',
    attributeEmptyValue: 'ویژگی {name} دارای مقدار نیست'
  },

  dataCategory: {
    generalInfo: 'اطلاعات عمومی',
    attributes: 'ویژگی ها',
    variables: 'متغیرها',
    plugin: 'اتصال ساز'
  },

  productType: {
    simple: 'ساده',
    variant: 'متغیر',
    service: 'خدمت'
  },

  pricing: {
    title: 'لیست قیمت ها',

    table: {
      header: {
        rowNumber: 'ردیف',
        name: 'عنوان',
        code: 'کد',
        barcode: 'بارکد',
        score: 'امتیاز',
        price: 'قیمت اصلی',
        inventoryCount: 'موجودی',
        salePrice: 'قیمت حراج',
        purchasePrice: 'قیمت خرید',
        purchaseAvgPrice: 'قیمت میانگین خرید',
        image: 'عکس',
        category: 'دسته بندی',
        variant: 'متغیر',
        creator: 'ایجاد کننده',
        type: 'نوع',
        status: 'وضعیت',
        shops: 'فروشگاه ها',
        lastModifiedDate: 'تاریخ بروزرسانی'
      },

      filters: {
        type: {
          all: 'همه',
          simpleProduct: 'محصول ساده',
          variableProduct: 'محصول متغیر'
        }
      }
    },

    notifications: {
      edit: {
        success: 'قیمت های محصول مورد نظر با موفقیت بروز شد',
        error: 'بروزرسانی قیمت های محصول مورد نظر با خطا همراه شد'
      }
    },

    validators: {
      price: 'قیمت معتبر نیست',
      salePrice: 'قیمت حراج معتبر نیست'
    },

    status: {
      notConnect: 'عدم اتصال',
      draft: 'پیش نویس',
      waiting: 'در انتظار',
      published: 'منتشر شده',
      personal: 'خصوصی'
    }
  },

  brands: {
    title: 'برند ها'
  }
}
